import { Button, Form, Input, Select, InputNumber } from 'antd';
import React, { useEffect, useState } from 'react';
import SearchAddress from '../../../Utils/SearchAddress';

const FormManagementCompany = ({ page, onSave, steps, current, onStepChange }) => {
  const [form] = Form.useForm();
  const [allFormData, setAllFormData] = useState({}); // Stocke toutes les données

  const formSteps = [
    {
      title: 'Informations 1/3',
      fields: [
        {
          name: 'registeredName',
          label: page.typeCompany === 'inde' ? 'Dénomination sociale de l\'entreprise' : 'Dénomination sociale de la maison mère*',
          type: 'input',
          rules: [
            { required: true, message: 'Entrez votre dénomination sociale!' },
            { max: 120, message: 'La dénomination sociale ne peut pas dépasser 120 caractères!' }
          ],
          props: { size: 'large', maxLength: 120 }
        },
        {
          name: 'siret',
          label: 'N° SIRET',
          type: 'input',
          rules: [
            { required: true, message: 'Entrez votre SIRET!' },
            {
              validator: (_, value) =>
                value && /^\d{14}$/.test(value)
                  ? Promise.resolve()
                  : Promise.reject(new Error('SIRET doit contenir exactement 14 chiffres!'))
            }
          ],
          props: { size: 'large' }
        },
        {
          name: 'postalAddress',
          label: 'Adresse postale',
          type: 'address',
          rules: []
        }
      ]
    },
    {
      title: 'Informations 2/3',
      fields: [
        {
          name: 'phone',
          label: 'Téléphone',
          type: 'input',
          rules: [
            { required: true, message: 'Entrez votre téléphone!' }
          ],
          props: { size: 'large' }
        },
        {
          name: 'email',
          label: 'Email',
          type: 'input',
          rules: [
            { required: true, message: 'Entrez votre email!' },
            { type: 'email', message: 'Email invalide!' }
          ],
          props: { size: 'large', type: 'email' }
        }
      ]
    },
    {
      title: 'Informations 3/3',
      fields: [
        {
          name: 'description',
          label: 'Description',
          type: 'textarea',
          rules: [],
          props: { rows: 4, size: 'large' }
        }
      ]
    }
  ];

  useEffect(() => {
    // Initialiser avec les données de la page
    const initialData = { ...page };
    setAllFormData(initialData);
    form.setFieldsValue(initialData);
  }, [page, form]);

  const handleNext = async () => {
    try {
      const currentStepValues = await form.validateFields();
      
      // Sauvegarder les données de l'étape actuelle
      const updatedFormData = { ...allFormData, ...currentStepValues };
      setAllFormData(updatedFormData);
      
      if (current < formSteps.length - 1) {
        onStepChange(current + 1);
      } else {
        // À la dernière étape, soumettre toutes les données
        onSave(updatedFormData);
      }
    } catch (error) {
      console.error('Validation failed:', error);
    }
  };

  const handlePrev = () => {
    // Sauvegarder les données de l'étape actuelle avant de reculer
    form.validateFields().then(currentStepValues => {
      const updatedFormData = { ...allFormData, ...currentStepValues };
      setAllFormData(updatedFormData);
      onStepChange(Math.max(0, current - 1));
    }).catch(() => {
      // Si validation échoue, reculer quand même
      onStepChange(Math.max(0, current - 1));
    });
  };

  const renderField = (field) => {
    const { name, label, type, rules, props = {} } = field;

    switch (type) {
      case 'input':
        return <Input {...props} />;
      case 'textarea':
        return <Input.TextArea {...props} />;
      case 'select':
        return <Select {...props} />;
      case 'number':
        return <InputNumber {...props} />;
      case 'address':
        return (
          <SearchAddress 
            onAddressChange={(fieldName, place) => {
              form.setFieldsValue({ [fieldName]: place });
            }}
            address={form.getFieldValue(name)}
            fieldName={name}
          />
        );
      default:
        return <Input {...props} />;
    }
  };

  const currentStep = formSteps[current];

  return (
    <Form form={form} layout="vertical" style={{ width: '100%' }}>
      <div className="mb-8">
        <h3 className="text-lg font-semibold mb-4">{currentStep.title}</h3>
        
        {currentStep.fields.map((field) => (
          <Form.Item
            key={field.name}
            label={field.label}
            name={field.name}
            rules={field.rules}
          >
            {renderField(field)}
          </Form.Item>
        ))}
      </div>

      <div className="flex justify-between">
        <Button 
          onClick={handlePrev}
          disabled={current === 0}
          size="large"
        >
          Précédent
        </Button>
        
        <Button 
          type="primary"
          onClick={handleNext}
          size="large"
        >
          {current === formSteps.length - 1 ? 'Enregistrer' : 'Suivant'}
        </Button>
      </div>
    </Form>
  );
};

export default FormManagementCompany;